import { useState } from "react";

const faqs = [
  {
    q: "How do I get an expedited passport in Fairbanks, Alaska?",
    a: "Fairbanks residents can use Fast Passport Center for 2–9 day expedited processing. Submit your application online, ship your documents overnight, and our registered courier agents submit at a U.S. passport agency on your behalf. The nearest regional agency to Fairbanks is in Seattle — over 1,600 miles away. We eliminate that trip entirely.",
  },
  {
    q: "Where is the nearest passport agency to Fairbanks?",
    a: "The Seattle Regional Passport Agency (915 2nd Ave, Seattle, WA 98174) is the nearest regional agency — requiring a full flight from Fairbanks. It handles same-day emergency appointments only. Fast Passport Center provides 2–9 day expedited processing without requiring you to travel to Seattle.",
  },
  {
    q: "Can I renew my passport by mail from Fairbanks?",
    a: "Yes — eligible adults can renew by mail using form DS-82. You must have a passport issued when you were 16 or older, that is less than 15 years old, and not reported lost or stolen. Fast Passport Center handles the full renewal process for Fairbanks residents by mail.",
  },
  {
    q: "How long does passport shipping take from Fairbanks?",
    a: "Overnight shipping from Fairbanks to the lower 48 typically takes 1–2 business days. Return shipping back to Fairbanks also takes 1–2 business days. In winter, weather delays can extend this — always factor in extra buffer time.",
  },
  {
    q: "How do I get a first-time passport in Fairbanks?",
    a: "First-time applicants must apply in person at an acceptance facility (such as Fairbanks Main Post Office, Airport Way Post Office, or FNSB Clerk) using form DS-11. Fast Passport Center guides you through every step — document preparation, scheduling, and post-submission processing.",
  },
  {
    q: "What if I need an emergency passport in Fairbanks?",
    a: "For genuine emergencies (travel within 72 hours), you must contact the Seattle Passport Agency for an appointment — which requires a flight from Fairbanks. For urgent but non-emergency travel (2–14 days), Fast Passport Center can typically process passports in 2–9 business days without the Seattle trip.",
  },
  {
    q: "Can military families at Fort Wainwright or Eielson AFB use Fast Passport Center?",
    a: "Yes. Military families stationed at Fort Wainwright or Eielson Air Force Base can use Fast Passport Center for passport renewals and new applications. We understand the documentation requirements unique to active duty service members and their dependents.",
  },
  {
    q: "How much does expedited passport service cost in Fairbanks?",
    a: "Government fees are set by the U.S. Department of State: $130 for renewal, $165 for a new adult passport. Fast Passport Center charges a separate service fee for professional preparation and courier submission. Get a full quote at fastpassportcenter.com/checkout.",
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Fairbanks Passport FAQs
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            Answers to the most common passport questions from Fairbanks and Interior Alaska residents.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-[#F7F8FA] transition-colors"
              >
                <h3 className="font-semibold text-[#1A365D] text-sm pr-4">{faq.q}</h3>
                <i className={`ri-arrow-down-s-line text-[#F6C344] text-lg flex-shrink-0 transition-transform ${open === i ? "rotate-180" : ""}`}></i>
              </button>
              {open === i && (
                <div className="px-6 pb-5 pt-1 bg-[#F7F8FA]">
                  <p className="text-gray-500 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}